// Shared date formatting for the admin panel.
//  - formatDate     -> dd-MMM-yy            e.g. 07-Jul-26
//  - formatDateTime -> dd-MMM-yy, h:mm AM/PM e.g. 07-Jul-26, 6:17 PM
// Returns '—' for empty/invalid values.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const _parse = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (value) => {
  const d = _parse(value);
  if (!d) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS[d.getMonth()];
  const year = String(d.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
};

export const formatDateTime = (value) => {
  const d = _parse(value);
  if (!d) return '—';
  // en-IN renders a lowercase meridiem ("6:17 pm"); upper-case it -> "6:17 PM".
  const time = d
    .toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true })
    .toUpperCase();
  return `${formatDate(value)}, ${time}`;
};
